import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { EMIX_ENDPOINT, WS_DESEMBARACO_ENDPOINT, WS_EXPORTACAO_ENDPOINT, WS_FOLLOW_UP_ENDPOINT, WS_IMPORTACAO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';


export async function fetchAllProcessoEmix() {

  return doGetQCXRequest([
    EMIX_ENDPOINT,
    WS_DESEMBARACO_ENDPOINT,
    WS_FOLLOW_UP_ENDPOINT,
  ]);

}

export async function integrarImportacao(id) {
    return doGetQCXRequest([
        EMIX_ENDPOINT,
        WS_DESEMBARACO_ENDPOINT,
        WS_IMPORTACAO_ENDPOINT,
        id,
    ]);
}

export async function integrarExportacao(id) {
    return doGetQCXRequest([
        EMIX_ENDPOINT,
        WS_DESEMBARACO_ENDPOINT,
        WS_EXPORTACAO_ENDPOINT,
        id,
    ]);
}

export async function consultar(id) {
    return doGetQCXRequest([
        EMIX_ENDPOINT,
        WS_DESEMBARACO_ENDPOINT,
        "followUp",
        "consulta",
        id
    ]);
}
